module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_7016.a7a35e33.png";